import React from 'react';
import { Box } from '@mui/material';
import {
  FunctionField,
  Labeled,
  RecordContextProvider,
  useGetOne,
  useRecordContext,
} from 'react-admin';

const PoolInformation = ({ id, gap }: { id: number; gap?: number }) => {
  const { data: pool } = useGetOne('Pool', { id });

  return (
    <RecordContextProvider value={pool}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap }}>
        <Labeled label="Pool Location">
          <FunctionField render={(record) => record?.location?.name} />
        </Labeled>
        <Labeled label="Pool Position(s)">
          <FunctionField
            render={(record) => record?.positions?.map((item) => item.display_name).join(', ')}
          />
        </Labeled>
      </Box>
    </RecordContextProvider>
  );
};

export const PoolInformationFields = ({ gap }: { gap?: number } = {}) => {
  const poolPq = useRecordContext();
  const poolPqa = poolPq?.admin_professional_qualification_attributes?.find(
    (attr) => attr.qualification_attribute?.slug === 'pro_pool_pool_id',
  );
  const poolId = poolPqa?.value;

  if (!poolId) {
    return null;
  }

  return <PoolInformation id={poolId} gap={gap} />;
};
